<ng-container [ngSwitch]="webauthPopupActualPage">
  <app-connection-to-external-bank-ok
    *ngSwitchCase="'CONNECTION_EXTERNAL_BANK_OK'"
  ></app-connection-to-external-bank-ok>

  <app-connection-to-external-bank-ko
    *ngSwitchCase="'CONNECTION_EXTERNAL_BANK_KO'"
  ></app-connection-to-external-bank-ko>

  <app-loader
    *ngSwitchCase="undefined"
  ></app-loader>
</ng-container>
